<template>
  <div :id="props.id" :class="twMerge('mb-8', props.appendClass)" :data-testid="props.dataTestid">
    <div
      :class="twMerge('mx-auto max-w-screen-xl px-4', props.containerClass)"
      :data-testid="props.dataTestid + '-container'"
    >
      <slot>
        <Blocks
          v-if="Object.entries(props.builderBlock).length"
          :parent="props.builderBlock?.id || ''"
          :path="`component.options.content`"
          :blocks="normalizedContent"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Blocks } from '@builder.io/sdk-vue';
import { twMerge } from 'tailwind-merge';
import { computed } from 'vue';

type BuilderBlock = {
  id?: string;
  [key: string]: any;
};

type Props = {
  containerClass?: string;
  appendClass?: string;
  builderBlock?: BuilderBlock;
  content?: object[] | object;
  id?: string;
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  containerClass: '',
  appendClass: '',
  builderBlock: () => ({}),
  content: () => ({}),
  id: undefined,
  dataTestid: 'molecule-section',
});

const normalizedContent = computed(() =>
  Array.isArray(props.content) ? props.content : [props.content]
);
</script>
